<div class="full" fxLayout="row" fxLayout.xs="column">
    <div class="full loginContainer" fxFlex="50%" fxFlex.xs="66.66%" fxFlex.sm="66.66%">
      <mat-card id="loginCard">
        <h1 id="cardTitle" class="mat-h1">ePos Manager</h1>
        <br>
        <h3 class="mat-h3 h3h6MarginTop">Change Password</h3>
        <h6 class="mat-h6 h3h6MarginTop">Renew your password</h6>
        <br>
        <div>
            <div class="mat-small alert alert-danger" [@slideInOut]="errorDisplay">
                Wrong Email or password.
            </div>
            <mat-form-field *ngIf="reset1" class="formInput" appearance="outline" floatLabel='always'>
                <mat-label class="formInputLabel">Email</mat-label>
                <mat-icon class="inputPrefixIcon" matPrefix>account_circle</mat-icon>
                <input appBlockQuotes matInput autocomplete="off" placeholder="Enter Your Email">
            </mat-form-field>

            <mat-form-field *ngIf="reset2" class="formInput" appearance="outline" floatLabel='always'>
                <mat-label>New Password</mat-label>
                <mat-icon class="inputPrefixIcon" matPrefix>password</mat-icon>
                <input appBlockQuotes matInput [(ngModel)]="passwordInput" autocomplete="off" placeholder="Enter Your New Password" [formControl]="userPasswordCheck" [type]="hidePass ? 'password' : 'text'">

                <!-- <mat-error *ngIf="passwordCheckingText && userPasswordCheck.errors?.required">Field cannot be empty
                </mat-error>
                <mat-error *ngIf="userPasswordCheck.errors?.maxlength">Field cannot be more than
                    {{ userPasswordCheck.errors?.maxlength.requiredLength }} characters
                </mat-error>
                <mat-error *ngIf="userPasswordCheck.errors?.invalidPassword">Password should have minimum 8 characters, at least 1 uppercase letter, 1 lowercase
                    letter and 1 number
                </mat-error> -->

                <button id="passwordButton" mat-icon-button matSuffix (click)="hidePass = !hidePass">
                  <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field *ngIf="reset3" class="formInput" appearance="outline" floatLabel='always'>
                <mat-label>Confirmed Password</mat-label>
                <mat-icon class="inputPrefixIcon" matPrefix>password</mat-icon>
                <input appBlockQuotes matInput autocomplete="off" placeholder="Enter Your Confirmed Password" [(ngModel)]="confirmpasswordInput" [type]="hidePass2 ? 'password' : 'text'">
                <button id="passwordButton2" mat-icon-button matSuffix (click)="hidePass2 = !hidePass2">
                  <mat-icon>{{hidePass2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>

          <button mat-flat-button id="loginButton" (click)="verifyPasswords()" color="primary">{{reset3 ? "Reset" : "Sent"}}</button>
        </div>
      </mat-card>
    </div>

    <div class="full" fxFlex="50%" fxFlex.xs="33.34%" fxFlex.sm="33.34%">
      <div class="bgImageContainer">
        <img class="full bgImage" src="../assets/images/testbg2.jpg"/>
        <div class="imageFooter mat-small">Copyright © {{currentYear}} Qube Apps Solutions Sdn. Bhd. All rights reserved.</div>
      </div>
    </div>
  </div>